export default "__VITE_ASSET__05453764__"